import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx } from "vue"

import { computed, ref, toRefs } from 'vue';

import OpenOrdersItemMobile from './OpenOrdersItemMobile.vue';
import MyOrdersListMobile from '../../components/MyOrdersListMobile.vue';
import { useOrdersListActive, useOrdersListMobile } from '../../useOrdersList';


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenOrdersListMobile',
  props: {
  authenticatedUser: { type: Boolean, required: true },
  marketId: { type: String, required: true },
  showAllMarkets: { type: Boolean, required: true },
  showOrderType: { type: Boolean, required: true },
},
  setup(__props) {

const props = __props;

const { marketId } = toRefs(props);

const useFocusedOrders = () => {
  const focusedOrderIds = ref<Array<string>>([]);

  const isOrderFocused = (id: string) => focusedOrderIds.value.includes(id);

  const toggleFocusForOrder = (id: string) => {
    if (focusedOrderIds.value.includes(id)) {
      focusedOrderIds.value.splice(focusedOrderIds.value.indexOf(id), 1);
    } else {
      focusedOrderIds.value.push(id);
    }
  };

  return {
    isOrderFocused,
    toggleFocusForOrder,
  };
};

const { activeOrdersDataToShow, getOrderById, getLimitedActiveOrdersDataToShow } = useOrdersListActive(marketId);

const { mobileHeader, cancelOrder } = useOrdersListMobile();
const { isOrderFocused, toggleFocusForOrder } = useFocusedOrders();

const showInfo = computed(() => Boolean(!activeOrdersDataToShow.value.allOrders.length));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(MyOrdersListMobile, {
    class: "open-orders-list-mobile",
    "authenticated-user": __props.authenticatedUser,
    "market-id": _unref(marketId),
    "mobile-header": [],
    "show-all-markets": __props.showAllMarkets,
    "show-info": showInfo.value,
    "is-filled-list": false,
    "show-order-type": __props.showOrderType
  }, {
    list: _withCtx(({ itemClass }) => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(getLimitedActiveOrdersDataToShow)(_unref(activeOrdersDataToShow).allOrders), (item) => {
        return (_openBlock(), _createElementBlock(_Fragment, null, [
          (_unref(getOrderById)(item.orderId))
            ? (_openBlock(), _createBlock(OpenOrdersItemMobile, {
                key: item.key,
                class: _normalizeClass(itemClass),
                "is-current-market-order": _unref(marketId) === item.instrumentCode,
                "show-order-type": __props.showOrderType,
                "swipe-area-visible": _unref(isOrderFocused)(item.orderId),
                order: _unref(getOrderById)(item.orderId),
                "cancel-order": _unref(cancelOrder),
                "is-futures": _unref(marketId).endsWith('_P'),
                onClick: ($event: any) => (_unref(toggleFocusForOrder)(item.orderId))
              }, null, 8, ["class", "is-current-market-order", "show-order-type", "swipe-area-visible", "order", "cancel-order", "is-futures", "onClick"]))
            : _createCommentVNode("", true)
        ], 64))
      }), 256))
    ]),
    _: 1
  }, 8, ["authenticated-user", "market-id", "show-all-markets", "show-info", "show-order-type"]))
}
}

})